module.exports = __webpack_public_path__ + "static/media/RecordAttachmentSVG.5289e9fd.svg";